import { createFileRoute } from "@tanstack/react-router";
import FeedbackPage from "@project/user/pages/community/feedback";

export const Route = createFileRoute("/_user/_community/feedback")({
  head: () => ({ meta: [{ title: "Feedback — Jivandhara" }] }),
  component: FeedbackPage,
});
